import { render, staticRenderFns } from "./PermissionTree.vue?vue&type=template&id=104624ae&"
import script from "./PermissionTree.vue?vue&type=script&lang=js&"
export * from "./PermissionTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports